import { render, staticRenderFns } from "./document-log-component.vue?vue&type=template&id=654e8e08&scoped=true"
import script from "./document-log-component.vue?vue&type=script&lang=js"
export * from "./document-log-component.vue?vue&type=script&lang=js"
import style0 from "./document-log-component.vue?vue&type=style&index=0&id=654e8e08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654e8e08",
  null
  
)

export default component.exports